import _asyncToGenerator from "C:/Users/Administrator/Desktop/shujukeshihuaqianduan/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import * as echarts from 'echarts';
import 'echarts/extension/bmap/bmap.js';
import { ElMessage } from 'element-plus';
import { onMounted, ref, inject, nextTick } from 'vue';
import MapHandle from './MapHandle';
import setHeatChartOptions from './setHeatChartOptions';
import getBMap from '@/utils/baiduMap.js';

var initPage = function initPage() {
  // 初始化页面
  var $api = inject('$api');
  var isLoading = ref(true); // 页面加载状态

  var heatMapList = ref([]); // 热力图数据

  var timeList = ref([]); // 时间轴数据

  var heatMaxValue = ref(null); // 选择的当前参数对应的最大值，用于设置热力图的颜色取值范围

  var heatMinValue = ref(null); // 选择的当前参数对应的最小值

  var chartDom = ref(null); // 热力图DOM

  var getHeatMap = function getHeatMap(params) {
    // 获取热力图数据
    isLoading.value = true;
    $api.getHeatMap(params).then(function (data) {
      // 数据获取成功
      var list = data.data,
          min = data.min,
          max = data.max;
      heatMapList.value = list;
      heatMaxValue.value = max;
      heatMinValue.value = min;
      timeList.value = list.map(function (item) {
        return item.time;
      });

      if (heatMapList.value.length) {
        // 当前筛选条件有数据返回
        drawHeatMap();
      } else {
        ElMessage({
          message: '暂无对应数据'
        });
      }

      isLoading.value = false;
    }).catch(function () {
      // 数据获取失败
      heatMapList.value = [];
      timeList.value = [];
      heatMaxValue.value = null;
      heatMinValue.value = null;
      drawHeatMap();
      isLoading.value = false;
    });
  };

  var drawHeatMap = function drawHeatMap() {
    // 绘制、更新热力图
    var chartInstance = echarts.init(chartDom.value);
    var option = setHeatChartOptions(heatMapList.value, timeList.value, heatMaxValue.value, heatMinValue.value);
    chartInstance.setOption(option, true);
  };

  return {
    isLoading: isLoading,
    heatMapList: heatMapList,
    chartDom: chartDom,
    getHeatMap: getHeatMap
  };
};

export default {
  components: {
    MapHandle: MapHandle
  },
  setup: function setup() {
    var _initPage = initPage(),
        isLoading = _initPage.isLoading,
        heatMapList = _initPage.heatMapList,
        chartDom = _initPage.chartDom,
        getHeatMap = _initPage.getHeatMap;

    onMounted(function () {
      nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getBMap();

              case 2:
                // 创建地图的全局对象后再绘制地图
                getHeatMap();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    });
    return {
      isLoading: isLoading,
      heatMapList: heatMapList,
      chartDom: chartDom,
      getHeatMap: getHeatMap
    };
  }
};